// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const testimonialSlider = () =>{
    if(document.querySelector('.kruse-testimonial-slider')){
        const sliders = document.querySelectorAll('.kruse-testimonial-slider');

        sliders.forEach(slider =>{
            slider.classList.remove('row');
            let controls = slider.querySelector('.swiper-nav');
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.15,
                spaceBetween: 24,
                preloadImages: false,
                navigation: {
                    nextEl: controls.querySelector('.swiper-button-next'),
                    prevEl: controls.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    711: {
                        slidesPerView: 1.5,
                    },
                    1025: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },

                }
            })
        })

    }
}
export default testimonialSlider;